/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_Resource_PlaceholderInputs */

const en_admin_permissions_resource_placeholder = /** @type {(inputs: Admin_Permissions_Resource_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. posts`)
};

const zh_admin_permissions_resource_placeholder = /** @type {(inputs: Admin_Permissions_Resource_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如 posts`)
};

/**
* | output |
* | --- |
* | "e.g. posts" |
*
* @param {Admin_Permissions_Resource_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_permissions_resource_placeholder = /** @type {((inputs?: Admin_Permissions_Resource_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_Resource_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_permissions_resource_placeholder(inputs)
	return zh_admin_permissions_resource_placeholder(inputs)
});
export { admin_permissions_resource_placeholder as "admin.permissions.resource_placeholder" }